"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var twitchTheme = {
  tenant: {
    primary: "#9146FF"
  }
};
var _default = exports["default"] = twitchTheme;